<template>
  <div class="common-card">
    <remark-list-add-new
      :is-add-new-receipt-document-description-sidebar-active.sync="isAddNewReceiptDocumentDescriptionSidebarActive"
      :data="receiptDocumentDescriptionData"
      :id="id"
      @refetch-data="refetchData"
    />

    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            收據單據備註管理
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex flex-wrap mobile-w100 mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋收據單據備註"
          />
          <b-button
            class="mobile-w100"
            v-if="ability.can('create', 'settings_receipt_document_description')"
            @click="addReceiptDocumentDescription"
          >
            新增
          </b-button>
        </div>
      </div>
    </b-card>

    <b-card class="bottom mb-0">
      <!-- Table -->
      <b-table
        ref="refReceiptDocumentDescriptionListTable"
        class="position-relative"
        :items="fetchReceiptDocumentDescriptions"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="沒有匹配的數據"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            :class="`action-trigger-btn ${
              receiptDocumentDescriptionsList.length <= 3 ? 'hor' : 'ver'
            }`"
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="EyeIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="ability.can('update', 'settings_receipt_document_description')"
              @click="editReceiptDocumentDescription(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">修改資料</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="ability.can('delete', 'settings_receipt_document_description')"
              @click="deleteReceiptDocumentDescription(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" />
              <span class="align-middle ml-50">刪除記錄</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

        <!-- Column: created_at -->
        <template #cell(created_at)="data">
          <div class="d-flex">
            {{ getDateTime(data.item.created_at) }}
          </div>
        </template>

        <!-- Column: updated_at -->
        <template #cell(updated_at)="data">
          <div class="d-flex">
            {{ getDateTime(data.item.updated_at) }}
          </div>
        </template>

        <!-- Column: content -->
        <template #cell(description)="data">
          <div v-html="data.item.description"></div>
        </template>

        <!-- Column: Status -->
        <template #cell(is_active)="data">
          <feather-icon
            v-if="data.item.is_active"
            icon="CheckIcon"
            size="18"
            class="mr-50 text-success"
          />
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">顯示 {{ dataMeta.from }} 到 {{ dataMeta.to }} 共 {{ dataMeta.of }} 條</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalReceiptDocumentDescriptions"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import useReceiptDocumentDescriptionsList from './useReceiptDocumentDescriptionsList'
import receiptDocumentDescriptionStoreModule from '../receiptDocumentDescriptionStoreModule'
import RemarkListAddNew from './RemarkListAddNew.vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    RemarkListAddNew,
  },
  data() {
    return {
      isAddNewReceiptDocumentDescriptionSidebarActive: false,
      receiptDocumentDescriptionData: {
        id: 0,
        name: '',
        description: '',
        sort_order: 1,
        is_active: 1,
      },
      id: 0,
    }
  },
  methods: {
    addReceiptDocumentDescription() {
      this.id = 0
      this.receiptDocumentDescriptionData = {
        id: 0,
        name: '',
        description: '',
        sort_order: 1,
        is_active: 1,
      }
      this.isAddNewReceiptDocumentDescriptionSidebarActive = true
    },
    editReceiptDocumentDescription(item) {
      this.id = item.id
      this.receiptDocumentDescriptionData = {...item}
      console.log(this.receiptDocumentDescriptionData)
      this.isAddNewReceiptDocumentDescriptionSidebarActive = true
    },
    deleteReceiptDocumentDescription(id) {
      this.$swal({
        title: '確定要刪除嗎？',
        text: '您將無法恢復此收據單據備註！',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '是的，刪除它！',
        cancelButtonText: '取消',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('receipt-document-description/deleteReceiptDocumentDescription', { id }).then(() => {
            this.refetchData()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: '已刪除！',
                text: '收據單據備註已被刪除。',
                icon: 'TrashIcon',
                variant: 'success',
              },
            })
          }).catch(error => {
            console.log(error)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: '刪除失敗',
                text: '刪除收據單據備註時出錯。',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
        }
      })
    },
  },
  setup() {
    const RECEIPT_DOCUMENT_DESCRIPTION_APP_STORE_MODULE_NAME = 'receipt-document-description'

    // Register module
    if (!store.hasModule(RECEIPT_DOCUMENT_DESCRIPTION_APP_STORE_MODULE_NAME)) store.registerModule(RECEIPT_DOCUMENT_DESCRIPTION_APP_STORE_MODULE_NAME, receiptDocumentDescriptionStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(RECEIPT_DOCUMENT_DESCRIPTION_APP_STORE_MODULE_NAME)) store.unregisterModule(RECEIPT_DOCUMENT_DESCRIPTION_APP_STORE_MODULE_NAME)
    })

    const {
      fetchReceiptDocumentDescriptions,
      tableColumns,
      perPage,
      currentPage,
      totalReceiptDocumentDescriptions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refReceiptDocumentDescriptionListTable,
      resolveIsActiveVariant,
      resolveIsActiveText,
      refetchData,
      isActiveFilter,
      ability,
      receiptDocumentDescriptionsList,
    } = useReceiptDocumentDescriptionsList()

    return {
      fetchReceiptDocumentDescriptions,
      tableColumns,
      perPage,
      currentPage,
      totalReceiptDocumentDescriptions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refReceiptDocumentDescriptionListTable,
      resolveIsActiveVariant,
      resolveIsActiveText,
      refetchData,
      isActiveFilter,
      ability,
      receiptDocumentDescriptionsList,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
